// extracted by mini-css-extract-plugin
export default {"title":"Courses_title__UUApJ","area":"Courses_area__7ceCB","dropdownManage":"Courses_dropdownManage__NWB6M"};